import { ExternalLinkIcon } from "@chakra-ui/icons";
import {
	Box,
	Button,
	Flex,
	Heading,
	Link,
	Text,
	useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

interface DeprecatedFeatureProps {
	featureName: string;
}

const DeprecatedFeature: React.FC<DeprecatedFeatureProps> = ({
	featureName = "This",
}) => {
	const bgColor = useColorModeValue("gray.50", "gray.900");
	const cardBg = useColorModeValue("white", "gray.800");
	const mutedTextColor = useColorModeValue("gray.600", "gray.400");

	return (
		<Flex
			flexGrow={1}
			width="100%"
			height="100%"
			justify="center"
			align="center"
			bg={bgColor}
			p={8}
		>
			<Box maxW="500px" p={8} textAlign="center" bg={cardBg}>
				<Heading as="h1" mb={4} size="xl">
					{featureName} feature is no longer available
				</Heading>

				<Text mb={6} color={mutedTextColor}>
					We're constantly improving our platform and some features may be
					deprecated or replaced. If you need assistance, please contact our
					support team.
				</Text>

				<Link
					href="https://www.laborhack.com/contact"
					isExternal
					_hover={{ textDecoration: "none" }}
				>
					<Button
						rightIcon={<ExternalLinkIcon w={5} h={5} />}
						fontSize="sm"
						colorScheme="blue"
						w="full"
						size="lg"
					>
						Contact Us
					</Button>
				</Link>
			</Box>
		</Flex>
	);
};

export default DeprecatedFeature;
